import { addDefinition } from '../classes/object-definition';
/* eslint-disable new-cap, func-names */
export function JsonConverter(converter) {
    return function (target, key) {
        const property = addDefinition(target.constructor).getProperty(key.toString());
        if (typeof converter === 'function') {
            property.converter = new converter();
        }
        else {
            property.converter = converter;
        }
    };
}
//# sourceMappingURL=json-converter.js.map